<template>
  <div>
    <div class="container-fluid login">
      <div class="container">
        <div class="row">
          <div class="col-lg-4 col-10 col-sm-8 mx-auto login-form">
            <router-link to="/" class="content-logo-principal">
              <div>
                <h1>
                  <a href="https://royalpag.com">
                         <img :src="img" style="width: 250px">
                  </a>
                </h1>
              </div>
            </router-link>
            <div v-if="!usuario.codigoSmsVerificado">
              <h2 class="text-center text-default-gray logo_h2" style="font-size: 16px; font-family: Roboto;">
                Verificação de código
              </h2>
              <p class="text-center text-default-gray" style="font-size: 14px; font-family: Roboto;">Por favor entre com o código do seu Google Authenticator.</p>
              <div class="card-body pt-0">
                <div class="row">
                  <div class="col-12">
                    <form class="well top4" @submit.prevent="verificarCodigoGoogle">
                      <div class="row justify-content-center">
                        <div class="form-group text-default-gray text-center">
                          <div class="col-sm-12">
                            <input type="text" v-model="usuario.codigoSms" name="token" id="token">
                            <button typeof="submit" class="btn btn-primary send-btn float-right" :disabled="!isWholeCheckCode" >
                              <i class="menu-icon ti-location-arrow text-white"></i></button>
                          </div>
                        </div>
                      </div>
                      <div class="row justify-content-center">
                        <div class="form-group text-default-gray text-center">
                          <label>Digite o código de 6 digitos</label>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
            <div v-else-if="(usuario.codigoSmsVerificado && usuario.selfieStep)">
              <h2 class="text-center text-default-gray logo_h2 pb-5" style="font-size: 16px; font-family: Roboto;">
                Verificação efetuada com sucesso!
              </h2>
              <div class="form-group">
                <input type="reset" :style="color" @click.prevent="entrar" value="Entrar" class="btn btn-primary btn-block"/>
              </div>
            </div>
            <div v-else-if="(usuario.codigoSmsVerificado && !usuario.selfieStep)">
              <h2 class="text-center text-default-gray logo_h2 pb-5" style="font-size: 16px; font-family: Roboto;">
                Seu código foi verificado, estamos quase no fim
              </h2>
              <div class="form-group">
                <input type="reset" @click.prevent="nextStep" value="Continuar" class="btn btn-primary btn-block"/>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  // import http from '@/service/http'
  import localforage from 'localforage'
  import 'bootstrap-pincode-input/css/bootstrap-pincode-input.css'
  import 'bootstrap-pincode-input/js/bootstrap-pincode-input'
  import { mapActions, mapGetters } from 'vuex'
  import site_style from '@/service/site_style'
  import telefon_token from '@/service/telefon_token'
  import http from '@/service/http'

  export default {
    name: 'Token',
    computed: {
      ...mapGetters(['getIt']),
      isWholeSendSms () {
        return this.tempo === 0
      },
      isWholeCheckCode () {
        return this.usuario.codigoSms.length === 6
      }
    },
    mounted () {
      if (window.location.href.indexOf('?') !== -1) {
        if (this.$route.query && this.$route.query.ieu) {
          this.usuario.codigoEmail = this.$route.query.ieu
          this.verificarCodigoEmail()
          // localforage.setItem('inviteId', this.$route.query.identificador)
          // this.saveRequest(this.$route.query.identificador, 'requisicao')
        }
      }
      let self = this
      this.$('#token').pincodeInput({
        hidedigits: false,
        inputs: 6,
        complete: function (value, e, errorElement) {
          self.usuario.codigoSms = value
          // self.verificarCodigoSms(value)
          console.log('Verificando...')
          // this.$('#pincode-callback').html('This is the complete callback firing. Current value:' + value)
        }
      })
      this.$('#token').pincodeInput().data('plugin_pincodeInput').focus()
      this.countdown()
    },
    data () {
      return {
        img: site_style.getLogo().default,
        color: site_style.getColor(),
        tempoTemp: 10,
        tempo: 10,
        contador: '',
        usuario: {
          key: '',
          value: '',
          codigoSms: '',
          codigoEmail: '',
          emailVerificado: false,
          codigoSmsVerificado: false,
          selfieStep: false
        }
      }
    },
    methods: {
      ...mapActions(['setIt']),
      ...mapActions('usuarios', ['checkCode', 'solicitarNovoCodigoSmsVerificacao']),
      ...mapActions(['setToken', 'setMenu']),
      ...mapActions('auth', ['setUsuario', 'loginFirebase']),
      entrar () {
        this.$router.push({ name: 'auth.index' })
      },
      nextStep () {
        this.$router.push({ name: 'auth.selfie' })
      },
      countdown () {
        if ((this.tempo - 1) >= 0) {
          var min = parseInt(this.tempo / 60)
          var seg = this.tempo % 60
          if (min < 10) {
            min = '0' + min
            min = min.substr(0, 2)
          }
          if (seg <= 9) {
            seg = '0' + seg
          }
          this.contador = min + ':' + seg
          setTimeout(() => {
            this.tempo--
            this.countdown()
          }, 1000)
          // console.log(this.tempo, this.isWholeSendSms)
        } else {
          this.tempo = 0
          this.contador = '00:00'
        }
      },
      async solicitarNovoSms () {
        let self = this
        this.usuario.key = 'I-INA-SYSTEM'
        let token = await localforage.getItem(this.usuario.key)
        let tokenAuth = await localforage.getItem('I-INA-SYSTEM-AUTH')
        this.usuario.token = tokenAuth
        this.usuario.value = token
        const verb = 'post'
        const { usuario } = this
        console.log(usuario)
        await this.solicitarNovoCodigoSmsVerificacao({ verb, usuario }).then((message) => {
          if (message) {
            self.usuario.codigoSmsVerificado = message.codigoSmsVerificado
            self.usuario.emailVerificado = message.emailVerificado
            self.usuario.selfieStep = message.selfieStep
            console.log(message)
            self.tempoTemp += 10
            self.tempo = self.tempoTemp
            self.countdown()
          }
        })
      },
      doLoginAdmin(response){

        var self = this;

        const {token} = response
        localforage.setItem('vpUser', response.id)
        localforage.setItem('unreadMessagesArquivadas', [])
        localforage.setItem('unreadMessages', [])
        localforage.setItem('token', token).then((token) => {
        
        var id = response.id.toString()
        var md5Key = telefon_token.getMD5(id)
        telefon_token.setCookie(`ROYALPAG_TELEFON_TOKEN_${id}`, md5Key, 30)

        self.setMenu(response.menu.data)
        self.setToken({token})
        self.setUsuario(response.id)
    
        this.$router.push({name: 'vp.index'})
          
        })
         
      },
       async doLogin (login, senha, ipCliente) {

        this.response = null
        this.telefone = ''
        this.ipCliente = JSON.stringify(this.getIpClient);
        var googleAuthenticatorCode = this.usuario.codigoSms;


        const response = await http.post(
          '/login',
          {login, senha, ipCliente, googleAuthenticatorCode}
        )

        this.showModalTelefone = false

        if (response.status === 200) {
          this.response = response

          if (this.$socket.disconnected) {
            this.$socket.connect(process.env.API_URL_SOCKET,  { resource: 'message/socket.io' })
          }
          console.log('autenticarFirebase: ' + response.data.data.autenticarFirebase)
          var errorCode = 0
          if (response.data.data !== undefined && response.data.data.autenticarFirebase) {
            var error = null
            error = await this.loginFirebase({login, senha})
            if (error.code !== undefined) {
              errorCode = 2
            }
            console.log('errorCode: ' + errorCode)
            if (errorCode === 0) {
              this.showModalTelefone = true
              if (response.data.data.telefone !== undefined) {
                this.telefone = response.data.data.telefone
              }
              if (response.data.data.fotoVerificada === true) {
                this.showModalTelefone = false
              }
            } else {
              this.showToast({verb: 'error', message: 'Usuário ou senha inválida', title: 'Falha no Login', options: null})
            }
          }
          if (!this.showModalTelefone && errorCode === 0) {
            
            const {token} = response.data.data
            localforage.setItem('vpUser', response.data.data.id)
            localforage.setItem('googleAuthenticatorQRCode', response.data.data.googleAuthenticatorQRCode)
            localforage.setItem('unreadMessagesArquivadas', [])
            localforage.setItem('unreadMessages', [])
            localforage.setItem('token', token).then((token) => {
              this.setMenu(response.data.data.menu.data)
              this.setToken({token})
              this.setUsuario(response.data.data.id) // setando o usuario
              console.log('role: ' + this.role)
              if (this.role !== null) {
               this.$router.push({name: 'vp.index'})
              }
            })
          }
        }
        else{
          
          if(response.data.message == "Telefone não verificado.") {
             this.showModalTelefone = true;
             
          } else if(response.data.message == "Codigo inválido.") {
            
             this.$router.push({ name: 'auth.verificacaogoogle', params: { tipo: "ADMINISTRADOR", login: login, senha: senha, ipCliente: ipCliente  }})
          }
        }
      },
      async verificarCodigoGoogle () {

        let self = this;

        var login = self.$route.params.login;
        var senha = self.$route.params.senha;
        var ipCliente = self.$route.params.ipCliente;

        await this.doLogin(login, senha, ipCliente);

      },
      async verificarCodigoEmail () {
        let self = this
        this.usuario.key = 'I-INA-SYSTEM'
        let token = await localforage.getItem('I-INA-SYSTEM')
        this.usuario.value = token
        const verb = 'post'
        const { usuario } = this
        console.log(usuario)
        await this.checkCode({ verb, usuario }).then((message) => {
          if (message) {
            self.usuario.codigoSmsVerificado = message.codigoSmsVerificado
            self.usuario.emailVerificado = message.emailVerificado
            self.usuario.selfieStep = message.selfieStep
            console.log(message)
          }
        })
      }
    }
  }
</script>

<style src="../../assets/css/login.css" scoped></style>
<style scoped>
  .token {
    text-align: center;
  }
  .top25 {
    margin-top: 25px;
  }
  .login {
    padding-top: 6.5%;
    padding-bottom: 2%;
    width: 100%;
    height: 100vh;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    /*background: radial-gradient(ellipse at center, #5A93AF 0%, #004E74 100%);*/
    /*background: radial-gradient(ellipse at center, #63B9B4 0%, #008C83 100%);*/
    overflow-y: auto;
  }
  .submit-btn {
    background-color: rgba(255,255,255, .2);
  }
  .send-btn i {
    font-size: 25px;
    -webkit-transform: rotate(133deg);
    -moz-transform: rotate(133deg);
    -ms-transform: rotate(133deg);
    -o-transform: rotate(133deg);
    transform: rotate(133deg);
    display: inline-block;
  }
</style>



// WEBPACK FOOTER //
// tokengoogle.vue?5533856c